if (!customElements.get('card-media-modal')) {
  customElements.define(
    'card-media-modal',
    class CardMediaModal extends ModalDialog {
      constructor() {
        super();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia(opener);
      }

      showActiveMedia(opener) {
        const targetId = opener.getAttribute('data-media-id');
        this.querySelectorAll('[data-media-id]').forEach((el) => {
          el.classList.toggle('active', el.getAttribute('data-media-id') === targetId);
        });
      }
    }
  );
}

// Delegated click handler — attached once regardless of how many carousels/modals render
if (!window.__cardMediaModalListenerAdded) {
  window.__cardMediaModalListenerAdded = true;
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.card-carousel__zoom-btn');
    if (!trigger) return;
    const modal = document.getElementById(trigger.getAttribute('data-modal-target'));
    if (modal) modal.show(trigger);
  });
}